export enum Actions {
  ShowMessage = 'show_message',
  HideMessage = 'hide_message',
  ShowConfirmation = 'show_confirmation',
  HideConfirmation = 'hide_confirmation',
  SetUser = 'set_user',
  RemoveUser = 'remove_user',
  SetSelectedCompany = 'set_selected_company',
  ResetSelectedCompany = 'reset_selected_company',
  SetSelectedContact = 'set_selected_contact',
  ResetSelectedContact = 'reset_selected_contact',
  SetSelectedProduct = 'set_selected_product',
  ResetSelectedProduct = 'reset_selected_product',
  SetSelectedMembership = 'set_selected_membership',
  ResetSelectedMembership = 'reset_selected_membership',
  SetInvoice = 'set_invoice',
  ResetInvoice = 'reset_invoice',
  SetInvoiceClientDetails = 'set_invoice_client_details',
  SetInvoiceErrors = 'set_invoice_errors',
  ResetInvoiceErrors = 'reset_invoice_errors',
  SetInvoiceProductInfo = 'set_invoice_product_info',
  ResetInvoiceProductInfo = 'reset_invoice_product_info',
  SetInvoicePaymentDetails = 'set_invoice_payment_details',
  SetInvoicePaymentDetailsMode = 'set_invoice_payment_details_mode',
  SetSelectedUser = 'set_selected_user',
  ResetSelectedUser = 'reset_selected_user',
  SetRecipientList = 'set_recipient_list',
  ResetRecipientList = 'reset_recipient_list',
  SetRecipientListContactTitles = 'set_recipient_list_contact_titles',
  SetRecipientListCompanyTypes = 'set_recipient_list_company_types',
  SetRecipientListName = 'set_recipient_list_name',
  SetRecipientListMemberships = 'set_recipient_list_memberships',
  SetRecipientListInterests = 'set_recipient_list_interests',
  SetRecipientListCountries = 'set_recipient_list_countries',
  SetRecipientListExcludedContacts = 'set_recipient_list_excluded_contacts',
  RecipientListIncludeContact = 'recipient_list_include_contact',
  RecipientListRemoveIncludedContact = 'recipient_list_remove_included_contact',
  SetInvoiceNotes = 'set_invoice_notes',
  SetInvoicePoNumber = 'set_invoice_po_number',
  SetMembershipStartDate = 'set_membership_start_date'
}
